import Core from './core';
import isArray from 'lodash/isArray';
import each from 'lodash/each';
import {
    setupPaywall,
    loadUser,
    findExternalAsset,
    setLanguage,
    openModal,
    closeModal,
    setForm,
    logoutUser,
    checkAccess,
} from './actions';
import { parseURLparams } from './utils';
import AssetsRenderer from './ui/renderers/assets';
import UserMenuRenderer from './ui/renderers/userMenu';
import ModalRenderer from './ui/renderers/modal';
import css from './assets/css/index.scss';
import {
    LOGIN_FORM,
    REGISTER_FORM,
    MY_ACCOUNT_FORM,
    PRICE_OPTS_FORM,
} from './constants/forms';

// SET DEVELOP MODE on SDK
import InPlayer from '@inplayer-org/inplayer.js';

if (process.env.REACT_APP_ENV !== 'production') {
    InPlayer.setConfig('develop');
}

function styles() {
    const id = 'inplayer-paywall-style';
    let style = document.getElementById(id);

    if (!style) {
        const head = document.getElementsByTagName('head')[0];
        style = document.createElement('style');
        style.type = 'text/css';
        style.setAttribute('id', id);
        head.appendChild(style);
    }

    if (style.styleSheet) {
        style.styleSheet.cssText = css;
    } else {
        style.innerHTML = css;
    }
}

export default class InplayerPaywall extends Core {
    constructor(clientID, assetIDs, options) {
        if (!isArray(assetIDs)) {
            throw new Error(
                'An `assetIDs` array must be provided as second argument.'
            );
        }

        super(clientID, options);

        const emitEventFn = this.emit.bind(this);
        this.store.dispatch(setupPaywall(clientID, emitEventFn, options));

        styles();

        // Check if social login
        if (window.location.href.includes('token')) {
            const params = parseURLparams({
                hash: ['token', 'refresh_token', 'expires'],
                search: ['asset_id'],
            });

            const { token, refresh_token, expires } = params.hash;

            if (token && refresh_token && expires) {
                //set the item
                localStorage.setItem(
                    'inplayer_token',
                    JSON.stringify({
                        access_token: token,
                        expires,
                        refresh_token,
                        account: {},
                        timestamp: Date.now(),
                    })
                );
            }

            window.history.replaceState({}, document.title, params.url);
        }

        const token = InPlayer.Account.getToken().token;
        if (token) {
            this.store.dispatch(loadUser());
        }

        const renderer = new AssetsRenderer(this.store);

        each(assetIDs, asset => {
            if (asset && asset.external && asset.external.id) {
                this.store.dispatch(
                    findExternalAsset(asset, asset => {
                        renderer.render(asset, true);
                    })
                );
            } else if (asset && asset.id) {
                renderer.render(asset);
            } else {
                console.warn(`Asset does not contain id property - ${asset}`);
            }
        });

        const menuRenderer = new UserMenuRenderer(this.store);
        menuRenderer.render('inplayer-menu-content', this.store);

        const modalID = 'inplayer-modal';
        const modalRenderer = new ModalRenderer(this.store);
        modalRenderer.render(modalID, { contentLabel: 'Inplayer Modal' });
    }

    setLanguage = language => {
        this.store.dispatch(setLanguage(language));
    };

    setForm = (form, isTriggerExternal) => {
        this.store.dispatch(setForm(form, isTriggerExternal));
    };

    setLoginScreen = () => {
        this.setForm(LOGIN_FORM, true);
        this.store.dispatch(openModal());
    };

    logoutUser = () => {
        if (this.isAuthenticated()) {
            this.store.dispatch(logoutUser());
            this.store.dispatch(closeModal());
        } else {
            console.warn(
                'The user needs to be authenticated in order to perform the logout action'
            );
        }
    };

    setRegisterScreen = () => {
        this.setForm(REGISTER_FORM, true);
        this.store.dispatch(openModal());
    };

    setMyAccountScreen = () => {
        if (this.isAuthenticated()) {
            this.setForm(MY_ACCOUNT_FORM);
            this.store.dispatch(openModal());
        } else {
            console.warn(
                'The user needs to be authenticated in order to show the Account Form'
            );
        }
    };

    isAuthenticated = () => {
        return InPlayer.Account.isSignedIn();
    };

    checkUserAccess = (assetId, clientId) => {
        this.store.dispatch(
            checkAccess(assetId, clientId, item => {
                // check if user has access to asset
                if (item.id) {
                    console.info('The user already has access');
                } else {
                    this.setForm(PRICE_OPTS_FORM);
                    this.store.dispatch(openModal(assetId));
                }
            })
        );
    };

    showPaywall = (assetId, type = null) => {
        const clientID = this.store.getState().paywall.clientID;

        if (!assetId || !this.isAuthenticated()) {
            this.setLoginScreen();
            console.warn('The asset id is not defined');
        }

        if (assetId && type) {
            const asset = {
                external: {
                    id: assetId,
                    type: type,
                },
            };

            this.store.dispatch(
                findExternalAsset(
                    asset,
                    this.checkUserAccess(assetId, clientID)
                )
            );
        } else if (assetId) {
            this.checkUserAccess(assetId, clientID);
        }
    };
}



// WEBPACK FOOTER //
// ./src/index.js